import { createActionGroup, emptyProps, props } from '@ngrx/store';

import { LastViewedArticle } from '../models';

export const LastViewedArticlesActions = createActionGroup({
  source: 'Medical Shop - LastViewedArticles',
  events: {
    'Fetch last viewed articles': emptyProps(),
    'Fetch last viewed articles success': props<{ lastViewedArticles: LastViewedArticle[] }>(),
    'Fetch last viewed articles error': emptyProps(),

    'Mark article as viewed': props<{ globalArticleId: string }>(),
    'Mark article as viewed success': emptyProps(),
    'Mark article as viewed error': emptyProps(),
  },
});
